import { ProgressBar } from "@design-lab/shared/ui";
import { Shirt } from "lucide-react";
import type { Side } from "@design-lab/shared";
import { useSpring, animated, easings } from "@react-spring/web";

type LoadingBarProps = {
  side: Side;
  startTime?: number | undefined;
  estimatedDuration: number;
};

export function LoadingBar({ side, startTime, estimatedDuration }: LoadingBarProps) {
  // Calculate on every render like LoadingBars does (no useMemo)
  const elapsed = startTime ? Math.max(0, Date.now() - startTime) : 0;
  const start = startTime ? Math.min(1, elapsed / estimatedDuration) : 0; // 0-1, capped at 1

  const { progressPercentage } = useSpring({
    from: { progressPercentage: start * 100 },
    to: { progressPercentage: startTime ? 98 : start * 100 },
    config: {
      duration: startTime ? estimatedDuration : 0,
      mass: 2,
      tension: 300,
      friction: 15,
      easing: easings.easeOutQuad
    }
  });

  const AnimatedProgressBar = animated(ProgressBar);

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-2 rounded-md border p-4 lg:gap-4">
      <div className="flex items-center justify-center gap-2">
        <Shirt className="size-6" />
        <p className="font-bold">
          <span className="capitalize">{side}</span> of Shirt
        </p>
      </div>

      <p className="text-sm text-slate-700">Uploading image</p>

      <p className="text-xs font-medium">
        <animated.span>
          {progressPercentage.to(v => `${Math.round(v)}% (Less than 1 minute remaining)`)}
        </animated.span>
      </p>

      <AnimatedProgressBar value={progressPercentage} />
    </div>
  );
}
